<template>
    <div>
        <el-row :gutter="10" :justify="`center`" :type="`flex`" class="desc">
            <el-col :xs="24" :sm="24" :md="22" :lg="18" :xl="18">
                <el-card shadow="always" :body-style="{background: '#409EFF', color: '#FFFFFF'}">
                    <H3>多媒体配置文件生成工具</H3>
                    <el-table
                            :data="devices"
                            style="width: 100%">
                        <el-table-column
                                prop="id"
                                label="配置ID">
                        </el-table-column>
                        <el-table-column
                                prop="name"
                                label="设备类型">
                        </el-table-column>
                    </el-table>
                    <ul>
                        <li>优先读取服务器配置文件</li>
                        <li>可配置多媒体终端和服务器的通讯方式、串口配置、主页面延迟加载时长</li>
                        <li>每次只能生成一类设备的配置文件</li>
                        <li>生成的配置文件以设备ID命名</li>
                        <li>目前配置文件的更新需要重启设备或者应用才可以生效</li>
                        <li>只有特殊项目才需要配置项目项，否则使用标准项目即可</li>
                        <li><a href="https://www.yuque.com/docs/share/5b198e9d-6b08-42b6-bf6a-74a5e02ca7d3?#"
                               target="view_window">查看配置字段说明</a></li>
                    </ul>
                </el-card>
            </el-col>
        </el-row>

        <el-row :gutter="10" :justify="`center`" :type="`flex`">
            <el-col :xs="24" :sm="24" :md="22" :lg="18" :xl="18">
                <el-form :model="ruleForm" :rules="rules" ref="ruleForm" label-width="90px">
                    <el-form-item label="设备类型" prop="deviceId">
                        <el-select v-model="ruleForm.deviceId" placeholder="请选择设备类型" @change="selectDevice">
                            <el-option v-for="item in devices" v-bind:key="item.id" :label="item.name" :value="item.id"></el-option>
                        </el-select>
                    </el-form-item>
                    <el-form-item v-if="ruleForm.deviceId" label="应用场景" prop="useType">
                        <el-radio-group v-model="ruleForm.useType">
                            <el-radio v-for="item in useTypes" :key="item.id" :label="item.id">{{item.name}}</el-radio>
                        </el-radio-group>
                    </el-form-item>
                    <el-form-item v-if="ruleForm.deviceId" label="版本号" prop="version">
                        <el-input-number v-model="ruleForm.version" :min="0" :max="100"></el-input-number>
                    </el-form-item>
                    <el-form-item v-if="ruleForm.deviceId" label="延迟加载" prop="delay">
                        <el-input-number v-model="ruleForm.delay" :min="3" :max="30" label="描述文字"></el-input-number>
                    </el-form-item>
                    <el-form-item v-if="ruleForm.deviceId" label="网络连接" required>
                        <el-select v-model="ruleForm.network" placeholder="请选择网络连接方式">
                            <el-option label="mqtt" value="mqtt"></el-option>
                            <el-option label="socket" value="socket"></el-option>
                        </el-select>
                    </el-form-item>
                    <el-form-item v-if="ruleForm.deviceId && ruleForm.network === 'socket'" label="NT端口" required>
                        <el-row>
                            <el-col :xs="10" :sm="3">
                                <el-select v-model="ruleForm.socketPort" placeholder="请选择NT端口">
                                    <el-option label="9995" value="9995"></el-option>
                                    <el-option label="7725" value="7725"></el-option>
                                </el-select>
                            </el-col>
                        </el-row>
                    </el-form-item>
                    <el-form-item v-if="ruleForm.deviceId" label="配置密码" prop="settingsPassword">
                        <el-input v-model="ruleForm.settingsPassword" minlength="6" style="width: 190px"></el-input>
                    </el-form-item>
                    <el-form-item v-if="ruleForm.deviceId" label="参数密码" prop="paramsDialogPassword">
                        <el-input v-model="ruleForm.paramsDialogPassword" minlength="6" style="width: 190px"></el-input>
                    </el-form-item>
                    <el-form-item v-if="ruleForm.deviceId" label="检测相机">
                        <el-switch
                                v-model="ruleForm.checkCamera"
                                active-color="#13ce66"
                                inactive-color="#ff4949">
                        </el-switch>
                    </el-form-item>
                    <el-form-item v-if="ruleForm.deviceId && ruleForm.deviceId === `a64`" label="检测屏幕">
                        <el-switch
                                v-model="ruleForm.checkScreen"
                                active-color="#13ce66"
                                inactive-color="#ff4949">
                        </el-switch>
                    </el-form-item>
                    <el-form-item v-if="ruleForm.deviceId" label="设备静音">
                        <el-switch
                                v-model="ruleForm.mute"
                                active-color="#13ce66"
                                inactive-color="#ff4949">
                        </el-switch>
                    </el-form-item>
                    <el-form-item v-if="ruleForm.deviceId" label="禁用自更新">
                        <el-switch
                                v-model="ruleForm.disableUpdate"
                                active-color="#13ce66"
                                inactive-color="#ff4949">
                        </el-switch>
                    </el-form-item>
                    <el-form-item v-if="ruleForm.deviceId" label="使用打印机">
                        <el-switch
                                @change="onUsePrinterChanged"
                                v-model="ruleForm.usePrinter"
                                active-color="#13ce66"
                                inactive-color="#ff4949">
                        </el-switch>
                    </el-form-item>
                    <el-form-item v-if="ruleForm.deviceId && ruleForm.usePrinter" label="打印机">
                        <el-radio-group v-model="ruleForm.printer">
                            <el-radio v-for="item in printers" :key="item.id" :label="item.id">{{item.name}}</el-radio>
                        </el-radio-group>
                    </el-form-item>
                    <el-form-item v-if="ruleForm.deviceId" label="串口配置" prop="type">
                        <el-checkbox-group v-model="ruleForm.type" :max="currentDevice.serialPort.length">
                            <el-checkbox v-for="item in currentDevice.serialFeature" v-bind:key="item.id" :label="item.name" name="type"></el-checkbox>
                        </el-checkbox-group>
                    </el-form-item>
                    <el-form-item v-for="feature in usedSerialFeature" v-bind:key="feature.id" :label="feature.name">
                        <el-row :gutter="10" :justify="`start`" :type="`flex`">
                            <el-col :lg="5">
                                <el-form-item :prop="feature.serialPort" :rules="{required: true, trigger: 'change'}">
                                    <el-select v-model="feature.serialPort" placeholder="请选择串口" @change="selectSerialPortPath">
                                        <el-option v-for="item in currentDevice.serialPort" :key="item.path" :label="item.path"
                                                   :value="item.path" :disabled="item.use"></el-option>
                                    </el-select>
                                </el-form-item>
                            </el-col>
                            <el-col :lg="5">
                                <el-select v-model="feature.baudRate" placeholder="请选择波特率">
                                    <el-option label="9600" value="9600"></el-option>
                                    <el-option label="115200" value="115200"></el-option>
                                </el-select>
                            </el-col>
                        </el-row>
                    </el-form-item>
                    <el-form-item v-if="ruleForm.type.includes(`电源板`)" label="板子类型" required>
                        <el-select v-model="ruleForm.powerBoard" placeholder="请选择板子类型">
                            <el-option v-for="item in powerBoards" v-bind:key="item.id" :label="item.name" :value="item.id"></el-option>
                        </el-select>
                    </el-form-item>
                    <el-form-item v-if="ruleForm.type.includes(`电源板`)" label="喂狗">
                        <el-switch
                                v-model="ruleForm.feedDog"
                                active-color="#13ce66"
                                inactive-color="#ff4949">
                        </el-switch>
                    </el-form-item>

                    <el-form-item v-if="ruleForm.type.includes(`电源板`) || ruleForm.type.includes(`读卡器`)" label="读卡设置">
                        <el-radio-group v-model="ruleForm.cardCodeRule">
                            <el-radio :label="0">原始数据</el-radio>
                            <el-radio :label="1">转十进制</el-radio>
                        </el-radio-group>
                    </el-form-item>
                    <el-form-item v-if="ruleForm.type.includes(`电源板`) || ruleForm.type.includes(`读卡器`)" label="卡号前缀">
                        <el-input v-model="ruleForm.cardCodePrefix" maxlength="8" style="width: 190px"></el-input>
                    </el-form-item>

                    <el-form-item v-if="ruleForm.deviceId" label="回调配置">
                        <el-checkbox-group v-model="ruleForm.shouldConfigFuncDevice" @change="onSelectConfigFuncDevice">
                            <el-checkbox label="读卡器"></el-checkbox>
                            <el-checkbox label="扫描枪"></el-checkbox>
                        </el-checkbox-group>
                    </el-form-item>

          <el-form-item v-for="(item, index) in ruleForm.callbackConfig" v-bind:key="item.deviceName"
                        :label="item.deviceName"
                        :prop="'callbackConfig.' + index + '.funcName'"
                        :rules="{required: true,message: '必填项', trigger: 'change'}">
            <el-select v-model="item.funcName" placeholder="请选择回调函数"
                       @change="onSelectCallbackConfig(item, $event)">
              <el-option v-for="item in func" v-bind:key="item.id" :label="item.name" :value="item.name"></el-option>
            </el-select>
          </el-form-item>

          <el-form-item v-if="ruleForm.deviceId" label="提示语">
            <el-checkbox-group v-model="ruleForm.hintTextSelected">
              <el-checkbox v-for="item in hintText" v-bind:key="item.id" :label="item.name"></el-checkbox>
            </el-checkbox-group>
          </el-form-item>
          <el-form-item v-if="ruleForm.hintTextSelected.includes(`人脸识别`)" label="识别成功" prop="recognitionSuccess">
            <el-input v-model="ruleForm.recognitionSuccess" minlength="6" style="width: 190px"></el-input>
          </el-form-item>
          <el-form-item v-if="ruleForm.hintTextSelected.includes(`人脸识别`)" label="识别失败" prop="recognitionFail">
            <el-input v-model="ruleForm.recognitionFail" minlength="6" style="width: 190px"></el-input>
          </el-form-item>
          <el-form-item>
            <el-button type="primary" @click="submitForm('ruleForm')">立即创建</el-button>
            <el-button @click="resetForm('ruleForm')">重置</el-button>
          </el-form-item>
        </el-form>
      </el-col>
    </el-row>
  </div>

</template>

<script>

import FileSaver from 'file-saver';

export default {
  name: 'App',
  data() {
    let commonRule = [
      {required: true, message: '必填项', trigger: 'blur'},
    ];
    return {
      fileList: [],
      ruleForm: {
        usedSerialFeature: [],
        deviceId: '',
        projectId: 0,
        network: 'mqtt',
        socketPort: '9995',
        name: '',
        delay: 15,
        version: 0,
        region: '',
        date1: '',
        date2: '',
        launcher: false,
        checkCamera: false,
        checkScreen: false,
        mute: false,
        disableUpdate: false,
        usePrinter: false,
        powerBoard: '',
        feedDog: false,
        settingsPassword: '123456',
        paramsDialogPassword: '123456',
        recognitionSuccess: '识别成功',
        recognitionFail: '识别失败',
        delivery: false,
        type: [],
        callbackConfig: [],
        hintTextSelected: [],
        useType: '',
        printer: '',
        resource: '',
        desc: '',
        cardCodeRule: 1,
        cardCodePrefix: '',
        shouldConfigFuncDevice: []
      },
      powerBoards: [
        {id: 0, name: '7寸接口板'},
        {id: 1, name: '10寸接口板'},
        {id: 2, name: '新10寸接口板'},
        {id: 3, name: 'USBHUB'},
        {id: 4, name: '主板守护板'},
        {id: 5, name: '19寸电源板'},
      ],
      product: [
        {id: 0, name: '标准项目'},
        {id: 1, name: '汉中中心医院'}
      ],
      useTypes: [
        {id: 0, name: '多媒体'},
        {id: 1, name: '班牌'}
      ],
      printers: [
        {id: 0, name: '美松'},
        {id: 1, name: '思普瑞特'}
      ],
      hintText: [
        {id: 0, name: '人脸识别'}
      ],
      func: [
        {id: 1, name: 'onRawInput'},
        {id: 2, name: 'getReadCardInfo'},
        {id: 3, name: 'android'}
      ],
      devices: [
        {
          id: 'default',
          name: '通用',
          serialPort: [
            {path: '/dev/ttyS3', use: false}
          ],
          serialFeature: [
            {id: 0, name: '读卡器', use: false, serialPort: '', baudRate: 9600},
            {id: 1, name: '门禁控制', use: false, serialPort: '', baudRate: 9600},
            {id: 2, name: '温感', use: false, serialPort: '', baudRate: 9600}
          ]
        },
        {
          id: 'a64',
          name: 'A64',
          serialPort: [
            {path: '/dev/ttyS3', use: false},
            {path: '/dev/ttyS4', use: false}
          ],
          serialFeature: [
            {id: 0, name: '读卡器', use: false, serialPort: '', baudRate: 9600},
            {id: 1, name: '门禁控制', use: false, serialPort: '', baudRate: 9600},
            {id: 2, name: '温感', use: false, serialPort: '', baudRate: 9600},
            {id: 3, name: '电源板', use: false, serialPort: '', baudRate: 9600},
            {id: 4, name: '扫描枪', use: false, serialPort: '', baudRate: 9600}
          ]
        },
        {
          id: 'langguo3288',
          name: '郎国3288',
          serialPort: [
            {path: '/dev/ttyS1', use: false},
            {path: '/dev/ttyS3', use: false},
            {path: '/dev/ttyS4', use: false}
          ],
          serialFeature: [
            {id: 0, name: '读卡器', use: false, serialPort: '', baudRate: 9600},
            {id: 1, name: '门禁控制', use: false, serialPort: '', baudRate: 9600},
            {id: 2, name: '温感', use: false, serialPort: '', baudRate: 9600},
            {id: 4, name: '扫描枪', use: false, serialPort: '', baudRate: 9600},
            {id: 5, name: '中控读卡器', use: false, serialPort: '', baudRate: 9600}
          ]
        },
        {
          id: 'hra3288',
          name: '华瑞安3288',
          serialPort: [
            {path: '/dev/ttyS3', use: false},
            {path: '/dev/ttyS4', use: false}
          ],
          serialFeature: [
            {id: 0, name: '读卡器', use: false, serialPort: '', baudRate: 9600},
            {id: 1, name: '门禁控制', use: false, serialPort: '', baudRate: 9600},
            {id: 2, name: '温感', use: false, serialPort: '', baudRate: 9600}
          ]
        },
        {
          id: 'xz928',
          name: '芯智928',
          serialPort: [
            {path: '/dev/ttyS3', use: false},
            {path: '/dev/ttyS4', use: false}
          ],
          serialFeature: [
            {id: 0, name: '读卡器', use: false, serialPort: '', baudRate: 9600},
            {id: 1, name: '门禁控制', use: false, serialPort: '', baudRate: 9600},
            {id: 2, name: '温感', use: false, serialPort: '', baudRate: 9600}
          ],
        }
      ],
      rules: {
        delay: [
          {required: true, trigger: 'blur'}
        ],
        version: [
          {required: true, trigger: 'blur'}
        ],
        settingsPassword: [
          {required: true, trigger: 'blur'},
          {min: 4, max: 8, message: '长度在 4 到 8 个字符', trigger: 'blur'}
        ],
        paramsDialogPassword: [
          {required: true, trigger: 'blur'},
          {min: 4, max: 8, message: '长度在 4 到 8 个字符', trigger: 'blur'}
        ],
        recognitionSuccess: commonRule,
        recognitionFail: commonRule,
        deviceId: [
          {required: true, message: '请选择设备类型', trigger: 'change'}
        ],
        type: [
          {type: 'array', trigger: 'change'}
        ],
        useType: [
          {required: true, message: '请选择应用场景', trigger: 'change'}
        ],
        serialPort: [
          {
            required: true,
            validator: (rules, value, cb) => {
              console.log(rules)
              console.log(value)
              console.log(cb)
              return cb();
            },
            trigger: "change"
          }
        ]
      }
    };
  },

  computed: {
    currentDevice() {
      return this.devices.find(device => {
        return device.id === this.ruleForm.deviceId
      });
    },


    usedSerialFeature() {
      let features = [];
      if (!this.ruleForm.deviceId) {
        return features
      }
      console.log(this.currentDevice.serialPort)
      this.currentDevice.serialFeature.forEach(feature => {
        if (this.ruleForm.type.includes(feature.name)) {
          feature.use = true;
          features.push(feature);
        } else {
          feature.use = false;
        }
      });
      return features
    }
  },

  methods: {
    onUploadFile(file, fileList) {
      console.log(file)
      console.log(fileList)
    },

    selectDevice(deviceId) {
      this.resetForm("ruleForm")
      this.ruleForm.deviceId = deviceId
    },

    selectSerialPortPath(path) {
      this.currentDevice.serialPort.forEach(serialPort => {
        serialPort.use = serialPort.path === path
      })
    },

    onSelectConfigFuncDevice(val) {
      console.log(val)
      if (!val || val.length === 0) {
        this.ruleForm.callbackConfig = [];
        return;
      }
      let tempConfig = [];
      for (let i = 0; i < val.length; i++) {
        let deviceId = null;
        if (val[i] === "读卡器") {
          deviceId = 0;
        }
        if (val[i] === "扫描枪") {
          deviceId = 4;
        }
        let config = this.ruleForm.callbackConfig.find(value => value.deviceId === deviceId);
        console.log(config)
        if (config) {
          tempConfig.push(config);
        } else {
          tempConfig.push({
            deviceId: deviceId,
            deviceName: val[i],
            funcName: '',
            funcId: 0,
          });
        }
      }
      this.ruleForm.callbackConfig = [];
      this.ruleForm.callbackConfig = this.ruleForm.callbackConfig.concat(tempConfig);
      console.log(this.ruleForm.callbackConfig)
    },

    onSelectCallbackConfig(config, funcName) {
      config.funcId = this.func.find(value => value.name === funcName).id
    },

    onUsePrinterChanged(val) {
      if (val) {
        this.ruleForm.printer = 0;
      } else {
        this.ruleForm.printer = '';
      }
    },

    submitForm(formName) {
      console.log(this.ruleForm)
      this.$refs[formName].validate((valid) => {
        console.log(valid)
        if (valid) {
          this.currentDevice.projectId = this.ruleForm.projectId;
          this.currentDevice.network = this.ruleForm.network;
          this.currentDevice.socketPort = this.ruleForm.socketPort;
          this.currentDevice.delay = this.ruleForm.delay;
          this.currentDevice.useType = this.ruleForm.useType;
          this.currentDevice.version = this.ruleForm.version;
          this.currentDevice.settingsPassword = this.ruleForm.settingsPassword;
          this.currentDevice.paramsDialogPassword = this.ruleForm.paramsDialogPassword;
          this.currentDevice.checkCamera = this.ruleForm.checkCamera;
          this.currentDevice.checkScreen = this.ruleForm.checkScreen;
          this.currentDevice.usePrinter = this.ruleForm.usePrinter;
          this.currentDevice.callbackConfig = this.ruleForm.callbackConfig;
          this.currentDevice.disableUpdate = this.ruleForm.disableUpdate;
          this.currentDevice.mute = this.ruleForm.mute;
          if (this.ruleForm.printer) {
            this.currentDevice.printer = this.ruleForm.printer;
          }
          if (this.ruleForm.recognitionSuccess) {
            this.currentDevice.recognitionSuccess = this.ruleForm.recognitionSuccess;
          }

          if (this.ruleForm.recognitionFail) {
            this.currentDevice.recognitionFail = this.ruleForm.recognitionFail;
          }
          this.currentDevice.powerBoard = this.ruleForm.powerBoard;
          this.currentDevice.feedDog = this.ruleForm.feedDog;
          // 读卡规则
          this.currentDevice.cardCodeRule = this.ruleForm.cardCodeRule;
          this.currentDevice.cardCodePrefix = this.ruleForm.cardCodePrefix;

          let list = [];
          list.push(this.currentDevice)
          const json = JSON.stringify(list);
          console.log(json)
          let blob = new Blob([json], {type: "text/plain;charset=utf-8"});
          FileSaver.saveAs(blob, this.currentDevice.id + ".json");
        } else {
          console.log('error submit!!');
          return false;
        }
      });
    },
    resetForm(formName) {
      this.ruleForm.callbackConfig = []
      this.$refs[formName].resetFields();
      console.log(this.ruleForm)
    }
  }
}
</script>

<style scoped>
.desc {
  margin: 20px 0;
}
</style>
